import { useEffect, useState } from "react";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { pushSupported, pushPermission, isPushSubscribed, subscribeToPush, unsubscribeFromPush } from "@/lib/push";
import { toast } from "sonner";

export default function PushToggle({ compact = false }) {
  const [supported, setSupported] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setSupported(pushSupported());
    if (pushSupported()) {
      isPushSubscribed().then(setSubscribed);
    }
  }, []);

  if (!supported) return null;

  const denied = pushPermission() === "denied";

  const toggle = async () => {
    setBusy(true);
    try {
      if (subscribed) {
        await unsubscribeFromPush();
        setSubscribed(false);
        toast.success("Push notifications turned off");
      } else {
        await subscribeToPush();
        setSubscribed(true);
        toast.success("Push notifications on — you'll know the second a match drops 🎯");
      }
    } catch (e) {
      toast.error(e.message || "Could not update notifications");
    } finally { setBusy(false); }
  };

  if (denied && !subscribed) {
    return (
      <div className={`${compact ? "text-xs" : "text-sm"} text-rose-600 flex items-center gap-1.5`} data-testid="push-denied">
        <BellOff className="w-4 h-4" /> Notifications blocked
      </div>
    );
  }

  return (
    <button
      onClick={toggle}
      disabled={busy}
      className={`btn-pill ${subscribed ? "btn-soft" : "btn-accent"} ${compact ? "!text-xs !py-1.5 !px-3" : "!text-sm !py-2"} disabled:opacity-60`}
      data-testid="push-toggle"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : subscribed ? <Bell className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
      {subscribed ? "Notifications on" : "Enable match alerts"}
    </button>
  );
}
